import React from 'react';
import { Countdown } from './Countdown';
import { OfferCard } from './OfferCard';
interface FinalCtaProps {
  countdownHours: number;
}
export function FinalCta({
  countdownHours
}: FinalCtaProps) {
  return <section className="bg-teal-800 py-10 text-cream-50 sm:py-20" aria-labelledby="ultima-oportunidad" data-id="element-95" data-mp="19f7ckzhac3aq">
      <div className="mx-auto max-w-4xl px-5 sm:px-8" data-id="element-96" data-mp="15bsmth3jo8k3">
        <h2 id="ultima-oportunidad" className="text-center font-display text-xl font-900 uppercase leading-tight sm:text-4xl" data-id="element-97" data-mp="1jcv83rmptety">
          No dejes pasar esta oportunidad
        </h2>

        <div className="mt-5 sm:mt-8" data-id="element-98" data-mp="1t37tfm2ctc15">
          <Countdown hours={countdownHours} label="Termina en" compact data-id="element-99" data-mp="1t252je5179l8" />
        </div>

        <div className="mt-5 sm:mt-10" data-id="element-100" data-mp="1o4dckpny5xjo">
          <OfferCard headingLevel="h3" data-id="element-101" data-mp="223mh2s2sj37t" />
        </div>
      </div>
    </section>;
}